export default __webpack_public_path__ + "static/strapi-logo-m-a956fc1eb82b0a4551ea96181678e15f.png";